import loadable from '@loadable/component';
import { routes as companiesRoutes } from './companies/routes';
import { routes as roleRoutes } from './role/routes';
import { routes as settingsRoutes } from './settings/routes';
import { routes as subscriptionsRoutes } from './subscriptions/routes';
import { routes as userRoutes } from './user/routes';
import { routes as dashboardRoutes } from './dashboard/routes';
import { routes as newsRoutes } from './news/routes';
import { routes as researchRoutes } from './research/routes';
import { routes as biRoutes } from './bi/routes';
import { routes as entitiesRoutes } from './entities/routes';
import { routes as technologiesRoutes } from './technologies/routes';
import { routes as productsRoutes } from './products/routes';
import { routes as facilitiesRoutes } from './facilities/routes';
import { routes as projectsRoutes } from './projects/routes';
import { routes as contextsRoutes } from './contexts/routes';
import { routes as superAdminRoutes } from './super-admin/routes';

const HomeLandingPage = loadable(() => import('./landing/page'));

export const routes = [
  {
    path: '',
    element: <HomeLandingPage />,
  },

  { path: 'dashboard', children: dashboardRoutes },
  { path: 'contexts', children: contextsRoutes },
  { path: 'news', children: newsRoutes },
  { path: 'research', children: researchRoutes },
  { path: 'entities', children: entitiesRoutes },
  { path: 'technologies', children: technologiesRoutes },
  { path: 'products', children: productsRoutes },
  { path: 'facilities', children: facilitiesRoutes },
  { path: 'projects', children: projectsRoutes },
  { path: 'bi', children: biRoutes },
  { path: 'subscriptions', children: subscriptionsRoutes },
  { path: 'user', children: userRoutes },
  { path: 'role', children: roleRoutes },
  { path: 'settings', children: settingsRoutes },
  { path: 'companies', children: companiesRoutes },
  { path: 'super-admin', children: superAdminRoutes },
];
